import React, { FC, useCallback } from "react";

import Tag from "antd/es/tag";
import Tooltip from "antd/es/tooltip";
import cn from "classnames";
import { useIntl } from "react-intl";

import FileTag from "@mapmycustomers/shared/types/entity/FileTag";
import File from "@mapmycustomers/shared/types/File";

import Chip from "../Chip";
import ListWithOverflowItem from "../ListWithOverflowItem";

import styles from "./FileTags.module.scss";

export interface FileTagsProps {
  className?: string;
  onRemoveTag?: (id: FileTag["id"]) => void;
  tagClassName?: string;
  tags: File["tags"];
}

const FileTags: FC<FileTagsProps> = ({ className, onRemoveTag, tags = [] }) => {
  const intl = useIntl();

  const overFlowRenderer = useCallback(
    (count: number) => {
      return (
        <Tooltip
          title={
            <div>
              {tags
                .slice(-count)
                .map(({ name }) => name)
                .join(", ")}
            </div>
          }
        >
          <Chip type="light">
            {intl.formatMessage(
              {
                id: "component.fileTags.overflow",
                defaultMessage: "+ {count}",
                description: "File Tags overflow rendered",
              },
              { count }
            )}
          </Chip>
        </Tooltip>
      );
    },
    [tags, intl]
  );

  return (
    <ListWithOverflowItem
      className={cn(styles.container, className)}
      overflowRender={overFlowRenderer}
    >
      {tags.map(({ id, name }) => (
        <Tag
          className={styles.tag}
          closable={!!onRemoveTag}
          key={id}
          onClose={() => onRemoveTag?.(id)}
        >
          <span className={styles.tagName}>{name}</span>
        </Tag>
      ))}
    </ListWithOverflowItem>
  );
};

export default FileTags;
